import { render, staticRenderFns } from "./productClassifyInfo.vue?vue&type=template&id=14cbddfc&scoped=true&"
import script from "./productClassifyInfo.vue?vue&type=script&lang=js&"
export * from "./productClassifyInfo.vue?vue&type=script&lang=js&"
import style0 from "./productClassifyInfo.vue?vue&type=style&index=0&id=14cbddfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cbddfc",
  null
  
)

export default component.exports